"use client";

export type SiteNavItem = {
  label: string;
  href: string;
};

function cleanNavItem(item: SiteNavItem) {
  return {
    label: item.label.trim(),
    href: item.href.trim(),
  };
}

export function ensureHomeLink(items: SiteNavItem[], homeLabel = "Home") {
  const normalized = items.map(cleanNavItem).filter((item) => item.label && item.href);
  const hasHome = normalized.some((item) => item.href === "#top");

  return hasHome
    ? normalized
    : [{ label: homeLabel, href: "#top" }, ...normalized];
}

export function normalizeNavItems(items: SiteNavItem[], homeLabel = "Home") {
  const seen = new Set<string>();

  return ensureHomeLink(items, homeLabel)
    .map(cleanNavItem)
    .filter((item) => item.label && item.href)
    .filter((item) => {
      if (seen.has(item.href)) return false;
      seen.add(item.href);
      return true;
    });
}

export function filterAvailableHashLinks(items: SiteNavItem[]) {
  if (typeof document === "undefined") return items;

  return items.filter((item) => {
    if (!item.href.startsWith("#")) return true;

    const targetId = item.href.slice(1);
    if (!targetId) return false;

    return document.getElementById(targetId) !== null;
  });
}

export function scrollToHref(href: string, reducedMotion: boolean) {
  if (typeof window === "undefined") return;

  if (!href.startsWith("#")) {
    window.location.assign(href);
    return;
  }

  const targetId = href.slice(1);
  const element = document.getElementById(targetId);

  if (!element) return;

  element.scrollIntoView({
    behavior: reducedMotion ? "auto" : "smooth",
    block: "start",
  });

  window.history.replaceState(null, "", href);
}
